import { FC } from 'react';
import styles from './FilteringControl.module.scss';

type Option = {
  value: string;
  label: string;
}

type Props = {
  options: Option[];
  value: string;
  onChange: (value: string) => void;
}

const FilteringControl: FC<Props> = ({ options, value, onChange }) => {
  return (
    <div className={styles.container}>
      {options.map(option => (
        <button
          key={option.value}
          className={`${styles.button} ${value === option.value ? styles.active : ''}`}
          onClick={() => onChange(option.value)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
};

export default FilteringControl;
